/**
 * Up to two initials from a display name OR a username/email, for an avatar fallback. Most migrated users have no
 * first/last name — only an email like `kilian.vorderderfler@takeda.com` — so split the local-part (before `@`) on
 * spaces / `.` / `_` / `-` and take the first two tokens' initials ("KV"), not just the first letter. Falls back to "?"
 * when empty. Codepoint-aware (astral-safe).
 *
 * The single source for this — the manual drawer, the reviewer dialog and the ratings list all render the same avatar,
 * so the logic lives here rather than copy-pasted (a copy already drifted once).
 */
export function initials(name: string): string {
  const local = name.trim().split("@")[0] ?? "";
  const parts = local.split(/[\s._-]+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = Array.from(parts[0]!)[0] ?? "";
  const last = parts.length > 1 ? (Array.from(parts[parts.length - 1]!)[0] ?? "") : "";
  return (first + last).toUpperCase();
}
